import {
  READ_ACTION,
  CREATE_ACTION,
  LEAD_RESOURCE,
  APPOINTMENT,
} from '@/constants/resources'

// As páginas do fluxo de report (report, central de pendências e novo compromisso) desenham o próprio
// cabeçalho (H1 + stepper do Figma), por isso não usam `pageTitle` (que liga o breadcrumb do layout).
export default [
  {
    path: '/compromissos',
    name: 'appointment-list',
    component: () => import('@/modules/appointment/views/AppointmentsList.vue'),
    meta: {
      resource: LEAD_RESOURCE,
      action: READ_ACTION,
      pageTitle: 'Compromissos',
    },
  },
  {
    // Antes de `/compromissos/:id/report`: "novo" não é um id.
    path: '/compromissos/novo',
    name: 'appointment-new',
    component: () => import('@/modules/appointment_report/views/NewAppointmentPage.vue'),
    meta: {
      resource: APPOINTMENT,
      action: CREATE_ACTION,
      // "Compromissos" fica marcado no menu (board v4-novo-compromisso).
      navActiveLink: 'appointments',
    },
  },
  {
    // Report de compromisso de QUALQUER tipo: Momento X → as perguntas do CX; Entrevista, Parceria, Negociação e
    // recrutamento de PN → as perguntas de sempre (StandardReportForm). `?origem=pendencias` = aberto pela central.
    path: '/compromissos/:id/report',
    name: 'appointment-report',
    component: () => import('@/modules/appointment_report/views/MomentXReportPage.vue'),
    meta: {
      resource: LEAD_RESOURCE,
      action: READ_ACTION,
      // "Compromissos" fica marcado no menu durante o report (board v4-report).
      navActiveLink: 'appointments',
    },
    props: true,
  },
  {
    // Endereço da página MX v2 antiga (nunca ligada) — mantido só para links salvos.
    path: '/compromissos/:id/report/momento-x',
    redirect: to => ({ name: 'appointment-report', params: { id: to.params.id }, query: to.query }),
  },
  {
    // Central de pendências: onde o PN travado resolve todos os reports pendentes.
    path: '/pendencias',
    name: 'report-pendencias',
    component: () => import('@/modules/appointment_report/views/ReportPendenciesPage.vue'),
    meta: {
      resource: LEAD_RESOURCE,
      action: READ_ACTION,
      // Com o menu travado, "Compromissos" é o único item liberado e leva para cá (fica marcado como ativo).
      navActiveLink: 'appointments',
    },
  },
]
